<div class="page-container">
    <div class="top-toolbar">
      <div class="sub-title">SINGLE ATHLETE METABOLIC PROFILING</div>
      <div class="title"><p>Single Athlete Metabolic Profiling</p></div>
      <mat-tab-group>
        <mat-tab label="Test Data">
          <div *ngIf="isPFMCLactate" class="section u-overlay-hidden">
            <div class="u-margin-top-30 u-margin-bottom-30" *ngIf="graphType === 1">
              <div class="section-title u-margin-bottom-30 u-font-weight-bolder">Time Series: <span class="u-font-weight-400">load-based lactate & VO2 kinetics</span></div>
              <app-kinetics-graph [config]="stepTestConfigGeneral"></app-kinetics-graph>
            </div>
            <div class="u-margin-top-30 u-margin-bottom-30" *ngIf="graphType === 2">
              <div class="section-title u-margin-bottom-30 u-font-weight-bolder">Time Series: <span class="u-font-weight-400">load-based lactate & VO2 kinetics</span></div>
              <app-kinetics-graph-step-test [config]="stepTestConfigGeneral"></app-kinetics-graph-step-test>
            </div>
            <div class="u-margin-top-30 u-margin-bottom-30" *ngIf="graphType > 2">
              <div class="section-title u-margin-bottom-30 u-font-weight-bolder">Time Series: <span class="u-font-weight-400">load-based lactate & VO2 kinetics</span></div>
              <app-multi-kinetics-graph-runs [config]="stepTestConfigGeneral"></app-multi-kinetics-graph-runs>
            </div>
          </div>
          <br>
          <div class="section">
            <div id="determination_of_metabolic_demand">
              <div></div>
            </div>
            <div id="test_data"></div>
          </div>
        </mat-tab>
      </mat-tab-group>
      <app-typical-error *ngIf="isShowTypicalError" [typicalErrorList]="typicalErrorList"></app-typical-error>
      <section class="btn-group">
        <button mat-raised-button (click)="handleCancelView(false, false, false, true)">Decline</button>
        <button mat-raised-button color="primary" (click)="handleAcceptView()">Accept</button>
        <button mat-raised-button color="primary" (click)="handleAcceptAndView()">Accept & View</button>
    </section>
      <div *ngIf="heatmapEnabled" class="u-margin-top-30">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>Show Detailed Error Analysis</mat-panel-title>
            <mat-panel-description>
              <mat-progress-bar *ngIf="!heatMapList.length" mode="indeterminate"></mat-progress-bar>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-heatmap *ngIf="heatMapList.length" [config]="heatMapList"></app-heatmap>
        </mat-expansion-panel>
      </div>
    </div>
  </div>
